/* Gallery lightbox for the PDP heroes. Clicking a normal tile opens a single
   image; clicking the label tile (carries data-ph-labels) opens a CAROUSEL —
   prev/next arrows + a thumbnail strip — so all flavour back-labels are browsable.
   The in-tile view stays clean (just the image). Shared by pdp-hero-bogo +
   pdp-hero-plan; both render [data-ph-glb] and .ph-gal__cell tiles. */
(function () {
  var glb = document.querySelector('[data-ph-glb]');
  if (!glb) return;
  var img = glb.querySelector('[data-ph-glb-img]');
  var prev = glb.querySelector('[data-ph-glb-prev]');
  var next = glb.querySelector('[data-ph-glb-next]');
  var thumbs = glb.querySelector('[data-ph-glb-thumbs]');
  var list = [], idx = 0;

  function render() {
    idx = (idx + list.length) % list.length;
    img.src = list[idx];
    var ts = thumbs.querySelectorAll('.ph-glb__thumb');
    for (var t = 0; t < ts.length; t++) ts[t].classList.toggle('is-on', t === idx);
  }
  function openGlb() {
    glb.classList.add('is-open'); glb.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
  }
  function esc(s) { return String(s).replace(/"/g, '&quot;'); }
  function openSingle(src, alt) {
    list = [src]; idx = 0; img.src = src; img.alt = alt || '';
    prev.hidden = true; next.hidden = true; thumbs.hidden = true; thumbs.innerHTML = '';
    openGlb();
  }
  function openCarousel(urls) {
    list = urls.filter(Boolean); idx = 0;
    if (!list.length) return;
    prev.hidden = list.length < 2; next.hidden = list.length < 2; thumbs.hidden = list.length < 2;
    thumbs.innerHTML = list.map(function (u, i) {
      return '<button class="ph-glb__thumb' + (i === 0 ? ' is-on' : '') + '" type="button" data-i="' + i + '"><img src="' + esc(u) + '" alt="" loading="lazy"></button>';
    }).join('');
    render(); openGlb();
  }
  function close() {
    glb.classList.remove('is-open'); glb.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = ''; img.src = '';
  }

  document.addEventListener('click', function (e) {
    var cellImg = e.target.closest('.ph-gal__cell img');
    if (cellImg) {
      var cell = cellImg.closest('.ph-gal__cell');
      var labels = cell && cell.getAttribute('data-ph-labels');
      if (labels) openCarousel(labels.split('|'));
      else openSingle(cellImg.currentSrc || cellImg.src, cellImg.alt);
      return;
    }
    if (e.target.closest('[data-ph-glb-prev]')) { idx--; render(); return; }
    if (e.target.closest('[data-ph-glb-next]')) { idx++; render(); return; }
    var thumb = e.target.closest('.ph-glb__thumb');
    if (thumb) { idx = Number(thumb.getAttribute('data-i')) || 0; render(); return; }
    if (e.target === glb || e.target.closest('[data-ph-glb-close]')) close();
  });
  document.addEventListener('keydown', function (e) {
    if (!glb.classList.contains('is-open')) return;
    if (e.key === 'Escape') close();
    else if (e.key === 'ArrowLeft' && list.length > 1) { idx--; render(); }
    else if (e.key === 'ArrowRight' && list.length > 1) { idx++; render(); }
  });
})();
